/*
 * @Author: yzr
 * @Date: 2020-12-02 14:34:59
 * @LastEditors: yzr
 * @LastEditTime: 2020-12-02 16:03:51
 */
import ProRule from './pro_rule.vue';

export default ProRule;
